<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Assigned SPA & LA Lawyer</h3>
        <b-form role="form">

            <!-- If same lawyer -->
            <b-row v-show="different_lawyer === 'not_accepted'">
                <b-col cols="12">
                    <b-form-group label="Law Firm">
                        <el-select v-model="form.law_firm" filterable placeholder="Select">
                            <el-option
                            v-for="firm in law_firms"
                            :key="firm.firm_id"
                            :label="firm.name"
                            :value="firm.firm_id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Lawyers">
                        <el-select v-model="form.lawyer" filterable placeholder="Select">
                            <el-option
                            v-for="lawyer in lawyers"
                            :key="lawyer.lawyer_id"
                            :label="lawyer.name"
                            :value="lawyer.lawyer_id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- For different lawfirm -->
            <b-row v-show="different_lawyer === 'accepted'">
                <b-col cols="12">
                    <b-form-group label="SPA Law Firm">
                        <el-select v-model="spa_form.law_firm" filterable placeholder="Select">
                            <el-option
                            v-for="firm in law_firms"
                            :key="firm.firm_id"
                            :label="firm.name"
                            :value="firm.firm_id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="SPA Lawyers">
                        <el-select v-model="spa_form.lawyer" filterable placeholder="Select">
                            <el-option
                            v-for="firm in law_firms"
                            :key="firm.firm_id"
                            :label="firm.name"
                            :value="firm.firm_id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- Checkbox -->
            <b-row>
                <b-col cols="12">
                    <b-form-checkbox
                    id="different_lawyer"
                    v-model="different_lawyer"
                    value="accepted"
                    unchecked-value="not_accepted"
                    class="mb-3"
                    >
                    LA or SPA is incharge by different lawyer
                    </b-form-checkbox>
                </b-col>
            </b-row>
            
            <b-row v-show="different_lawyer === 'accepted'">
                <b-col cols="12">
                    <b-form-group label="LA Law Firm">
                        <el-select v-model="la_form.law_firm" filterable placeholder="Select">
                            <el-option
                            v-for="firm in law_firms"
                            :key="firm.firm_id"
                            :label="firm.name"
                            :value="firm.firm_id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="LA Lawyers">
                        <el-select v-model="la_form.lawyer" filterable placeholder="Select">
                            <el-option
                            v-for="firm in law_firms"
                            :key="firm.firm_id"
                            :label="firm.name"
                            :value="firm.firm_id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'

export default {
    props:{
        show_assign_lawyer: Boolean,
    },
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    computed: {
        show: {
            get() {
                return this.show_assign_lawyer
            },
            set(newVal) {
                this.$emit('update:show_assign_lawyer', newVal)
            },
        },
    },
    data() {
        return {
            form: {
                law_firm: '',
                lawyer: '',
            },
            different_lawyer: 'not_accepted',
            la_form: {
                law_firm: '',
                lawyer: '',
            },
            spa_form: {
                law_firm: '',
                lawyer: '',
            },
            law_firms: [
                {
                    firm_id: 1,
                    name: 'John Doe',
                },
                {
                    firm_id: 2,
                    name: 'Bear Grylls',
                },
            ],
            lawyers: [
                {
                    lawyer_id: 1,
                    name: 'John Doe',
                },
                {
                    lawyer_id: 2,
                    name: 'Bear Grylls',
                },
            ]
        }
    }
}
</script>